// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_c1-2";
export var aiChatCartContainerExit = "_c1-4";
export var aiChatContainerLarge = "_c1-0";
export var aiChatContainerSmall = "_c1-1";
export var aiChatIcon = "_c1-6";
export var slideInFromRight = "_c1-3";
export var slideOutToRight = "_c1-5";